import Head from 'next/head';
import React, { memo } from 'react';

interface MetaProps {
    title?: string;
    image?: string;
    description?: string;
    keywords?: { name: string }[];
    author?: string;
}

const removeHTMLTags = (html: string): string => {
    return html.replace(/<[^>]+>/g, '');
};

const Meta: React.FC<MetaProps> = ({ title, image, description, keywords }) => {
    const cleanDescription = description
        ? removeHTMLTags(description)
        : title || '';

    const keywordsContent = keywords
        ? keywords.map((e) => e?.name).join(', ')
        : title || '';

    return (
        <Head>
            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={cleanDescription} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content="https://soff.uz" />
            <meta property="og:site_name" content="soff.uz" />
            <meta property="og:keywords" content={keywordsContent} />

            {/* Twitter */}
            <meta property="twitter:image" content={image} />
            <meta property="twitter:type" content="website" />
            <meta property="twitter:title" content={title} />
            <meta
                property="twitter:description"
                content={
                    description
                        ? removeHTMLTags(description)
                        : `${title} | Soff | Soff online hujjatlar bazasi`
                }
            />
            <meta property="twitter:url" content="soff.uz" />
            <meta property="twitter:site_name" content="Soff.uz" />
            <meta property="twitter:keywords" content={keywordsContent} />
        </Head>
    );
};

export default memo(Meta);

